import { Component, OnInit, Input } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FormGroup } from '@angular/forms';
import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';

@Component({
  selector: 'app-dynamic-son-multi-select',
  templateUrl: './dynamic-son-multi-select.component.html',
  styleUrls: ['./dynamic-son-multi-select.component.scss']
})
export class DynamicSonMultiSelectComponent implements OnInit {
  
  @Input() parentForm: FormGroup;
  @Input() listSource;
  @Input() itemType;
  @Input() fieldId;
  //@Input() settings:IDropdownSettings;
  
settings:IDropdownSettings;
dropdownList = [];
selectedItems=[];

dropdownSettings:IDropdownSettings={};
myItems=[];
  constructor(private zenplansTestDataProviderService: ZenplansTestDataProviderService) { }
  
  async ngOnInit() {
     var kuku = await this.zenplansTestDataProviderService.getSectionItemIdsAndNames(this.listSource,this.itemType);
     this.dropdownList = kuku;
    // this.dropdownList = [
    //   { item_id: 'Mumbai', item_text: 'Mumbai' },
    //   { item_id: 'Bangaluru', item_text: 'Bangaluru' },
    //   { item_id: 'Pune', item_text: 'Pune' },
    //   { item_id: 'Navsari', item_text: 'Navsari' },
    //   { item_id: 'New Delhi', item_text: 'New Delhi' }
    // ];
    this.selectedItems = this.parentForm.controls[this.fieldId].value;
    // this.selectedItems = [
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' }
    // ];
    this.dropdownSettings= {
      singleSelection: false,
      idField: 'Id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };
  }
  onItemSelect(item: any) {
    console.log(item);
    this.myItems.push(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  onDropDownClose(){
    this.parentForm.controls[this.fieldId].setValue(this.myItems);
  }
}
